import { FieldTypeConfig } from '@ngx-formly/core';
import { FileInputComponent } from 'src/app/features/questionnaire';

export function getFileUploadFieldConfig(): Partial<FieldTypeConfig> {
  return { type: FileInputComponent };
}
